import { getName } from 'country-list';

export function getCountryNameFromCountryCode(countryCode: string): string {
    return countryCode ? getName(countryCode) || '' : '';
};